import { createUseStyles } from 'react-jss'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  root: {
    width: '100%',
  },
  label: {
    paddingLeft: 72,
    width: '100%',
    '&::before': {
      content: "'*'",
      color: theme.palette.error.main,
    },
  },

  startAdorement: {
    position: 'relative',
    top: [-5],
  },
  whiteBg: {
    background: 'white',
  },

  textField: {
    background: 'white',
    width: '100%',
    paddingLeft: 16,

    '& div': {
      marginTop: 0,
    },

    '& svg': {
      width: 20,
      height: 20,
    },

    '& svg > path': {
      fill: theme.palette.grey[800],
    },

    paddingBottom: 6,
    '& .birthdayInput': {
      color: theme.palette.grey[800],
      margin: 0,
      border: 0,
      fontSize: 16,
      fontFamily: 'Sarabun',
      fonteight: 400,
    },
  },
  selectDifferentTreatmentLink: {
    color: theme.palette.info.main,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}))
